// Web client apiKey (Firebase Console → Project settings → General → Web app).
// Set FIREBASE_WEB_API_KEY / FIREBASE_WEB_API_KEY_PROD in backend/.env.local; config-overrides.js
// mirrors them to REACT_APP_* so CRA injects them (see react-scripts/config/env.js).

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const sandboxFirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_WEB_API_KEY || "",
  authDomain: "getprenup.firebaseapp.com",
  projectId: "getprenup",
  storageBucket: "getprenup.firebasestorage.app",
  messagingSenderId: "189847500779",
  appId: "1:189847500779:web:d1d8c34ea29df1e5b9cbae",
  measurementId: "G-7SK4G6XPS6",
};

export const prodFirebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_WEB_API_KEY_PROD ||
    process.env.REACT_APP_FIREBASE_WEB_API_KEY ||
    "",
  authDomain: "colorheart-ac359.firebaseapp.com",
  projectId: "colorheart-ac359",
  storageBucket: "colorheart-ac359.firebasestorage.app",
  messagingSenderId: "710986914773",
  appId: "1:710986914773:web:0d1d429cf9824dfe65fb5c",
  measurementId: "G-FTLVKSW7R0",
  // Performance optimizations for production
  authEmulatorHost: null, // Ensure no emulator in production
  databaseURL: null, // Not using Realtime Database
  // Additional performance settings
  experimentalForceLongPolling: false, // Use WebSocket when possible
  experimentalAutoDetectLongPolling: false, // Disable auto-detection
};
